import React from "react";
import Navbar from "../../components/base/landing/navbar";
import FooterLanding from "../../components/base/landing/footer";
import Intensivo from "../../components/base/landing/intensivo";
import WhatsApp from "../../components/base/whatsapp";
import BlogButton from "../../components/base/blog";



const IntensivoPage = () => {
    return (
      <>
        <Navbar />
        <Intensivo/>
        <FooterLanding/>
        <BlogButton/>
        <WhatsApp/>
      </>
    );
  };
  
  export default IntensivoPage;